import React, { useRef } from "react";
import { Card, Table } from "antd";
import { getResponseColumns, getResponseSkeletonColumns, getSkeletonRows } from "./npsTableColumns";
import NPSCardHead from "./NPSCardHead";
import "./NPSRecentResponses.css";

const NPSRecentResponses = ({ responses, isLoading, onViewAll }) => {
  const scoreBadges = useRef(new Map());

  const registerScoreRef = (id, el) => {
    if (el) scoreBadges.current.set(id, el);
    else scoreBadges.current.delete(id);
  };

  return (
    <Card className="nps-card nps-recent-card" bodyStyle={{ padding: 0 }}>
      <NPSCardHead
        title="Recent responses"
        note={isLoading ? "Loading submissions…" : `Latest ${responses.length} submissions`}
        right={
          <button type="button" className="nps-link-btn" onClick={onViewAll}>
            View all responses →
          </button>
        }
      />
      <Table
        className="nps-recent-table"
        rowKey="id"
        dataSource={isLoading ? getSkeletonRows(6) : responses}
        columns={isLoading ? getResponseSkeletonColumns() : getResponseColumns(registerScoreRef)}
        pagination={false}
        scroll={{ x: 560 }}
        onRow={isLoading ? undefined : (record) => ({
          onMouseEnter: () => scoreBadges.current.get(record.id)?.play(),
        })}
      />
    </Card>
  );
};

export default NPSRecentResponses;
